module.exports = __webpack_public_path__ + "img/appointments.0749be15.jpeg";